<template>
  <div class="project-container">
    <!-- Contenu du CV -->
    <div class="cv-paper">
      <!-- Header / Profil -->
      <header class="hero-section compact-hero">
        <div class="hero-content">
          <h1 class="hero-title">Timothé <span class="highlight">Natté</span></h1>
          <p class="hero-subtitle">Étudiant en BUT Informatique (3ème année)</p>
          <p class="profile-description">
            Passionné par le développement Full Stack et l'architecture logicielle, je suis un développeur curieux et autonome,
            toujours prêt à relever des défis techniques pour concevoir des solutions innovantes et performantes.
          </p>
          <div class="hero-meta">
            <span class="meta-item"><i class="mdi mdi-phone"></i> 06 11 48 53 28</span>
            <span class="meta-item"><i class="mdi mdi-email"></i> timothe.natte@proton.me</span>
            <span class="meta-item"><i class="mdi mdi-map-marker"></i> Montpellier</span>
            <span class="meta-item"><i class="mdi mdi-car"></i> Permis B</span>
          </div>
        </div>
        <div class="hero-image">
          <div class="profile-photo-container">
            <img :src="require('@/assets/image/timothe_photo.jpg')" alt="Timothé Natté" class="profile-photo"/>
          </div>
        </div>
      </header>

      <div class="cv-grid">
        <!-- Main Column -->
        <div class="main-column">
          <!-- Expérience Pro -->
          <section class="cv-section">
            <div class="section-header">
              <h2>Expérience Professionnelle</h2>
            </div>
            <div class="section-content">
              <div class="experience-item">
                <div class="item-header">
                  <h3>Stage Développeur Full Stack - GAGNE</h3>
                  <span class="date">2025</span>
                </div>
                <p class="item-subtitle">Groupe BRIAND - Construction Métallique</p>
                <p class="item-desc">Digitalisation de la gestion d'un atelier de peinture industrielle pour remplacer les processus manuels.</p>
                <ul class="detail-list">
                  <li>Conception d'une architecture micro-services (Symfony/Vue.js).</li>
                  <li>Développement d'interfaces tactiles pour opérateurs.</li>
                  <li>Intégration de matériel industriel (scannettes, imprimantes).</li>
                </ul>
                <p class="learning-text"><strong>Acquis :</strong> Développement Full Stack en environnement industriel et gestion du cycle de vie applicatif.</p>
              </div>
            </div>
          </section>

          <!-- Projets -->
          <section class="cv-section">
            <div class="section-header">
              <h2>Projets Marquants</h2>
            </div>
            <div class="section-content">

              <div class="experience-item">
                <div class="item-header">
                  <h3>Home Lab Cloud - Infrastructure & SecOps</h3>
                  <span class="date">2024 - Présent</span>
                </div>
                <p class="item-desc">Déploiement d'un cloud privé haute disponibilité pour l'auto-hébergement et l'expérimentation.</p>
                <ul class="detail-list">
                  <li>Orchestration d'un cluster Kubernetes (K3s) sur Proxmox.</li>
                  <li>Automatisation GitOps (ArgoCD) et SSO (Zitadel).</li>
                  <li>Monitoring complet (Prometheus/Grafana).</li>
                </ul>
                <p class="learning-text"><strong>Acquis :</strong> Administration système, orchestration Kubernetes et pratiques DevSecOps.</p>
              </div>

              <div class="experience-item">
                <div class="item-header">
                  <h3>Nuit de l'Info - Lead Tech Frontend</h3>
                  <span class="date">2025</span>
                </div>
                <p class="item-desc">Développement d'une plateforme événementielle et d'un jeu interactif en 24h.</p>
                <ul class="detail-list">
                  <li>Lead Tech et mentorat d'une équipe de 4 développeurs.</li>
                  <li>Architecture frontend moderne (Next.js 16, React 19).</li>
                  <li>Mise en place pipeline CI/CD et déploiement GitOps.</li>
                </ul>
                <p class="learning-text"><strong>Acquis :</strong> Leadership technique et déploiement continu sous pression.</p>
              </div>

              <div class="experience-item">
                <div class="item-header">
                  <h3>PikuTrade - Bot Trading IA</h3>
                  <span class="date">12/2024</span>
                </div>
                <p class="item-desc">Création d'un bot de trading crypto autonome avec analyse IA.</p>
                <ul class="detail-list">
                  <li>Développement d'une API REST performante (Spring Boot).</li>
                  <li>Intégration Deeplearning4j pour l'analyse prédictive.</li>
                  <li>Gestion asynchrone des ordres et Rate Limiting.</li>
                </ul>
                <p class="learning-text"><strong>Acquis :</strong> Backend haute performance et Deep Learning appliqué à la finance.</p>
              </div>

              <div class="experience-item">
                <div class="item-header">
                  <h3>SAE Référendum - Vote Sécurisé</h3>
                  <span class="date">10/2024 - 03/2025</span>
                </div>
                <p class="item-desc">Conception d'un système de vote électronique anonyme et vérifiable.</p>
                <ul class="detail-list">
                  <li>Implémentation du chiffrement homomorphe ElGamal modifié.</li>
                  <li>Architecture client-serveur sécurisée (Sockets TLS).</li>
                  <li>Preuves à divulgation nulle de connaissance (ZKP).</li>
                </ul>
                <p class="learning-text"><strong>Acquis :</strong> Cryptographie avancée et architecture logicielle sécurisée.</p>
              </div>

              <div class="experience-item">
                <div class="item-header">
                  <h3>Code Game Jam</h3>
                  <span class="date">2024</span>
                </div>
                <p class="item-desc">Création d'un jeu multijoueur "Donjons Multijoueurs" en 24h.</p>
                <ul class="detail-list">
                  <li>Level Design et modélisation 3D sous Unity.</li>
                  <li>Scripting C# des mécaniques et interactions.</li>
                  <li>Optimisation des assets pour le multijoueur local.</li>
                </ul>
                <p class="learning-text"><strong>Acquis :</strong> Prototypage rapide et travail d'équipe intensif.</p>
              </div>
            </div>
          </section>

          <!-- Formations -->
          <section class="cv-section">
            <div class="section-header">
              <h2>Formations</h2>
            </div>
            <div class="section-content">
              <div class="experience-item">
                <div class="item-header">
                  <h3>BUT Informatique</h3>
                  <span class="date">2023 - 2026</span>
                </div>
                <p class="item-subtitle">IUT Montpellier\Sète - Parcours DACS (Système & Réseau)</p>
              </div>
              <div class="experience-item">
                <div class="item-header">
                  <h3>Bac STI2D</h3>
                  <span class="date">2023</span>
                </div>
                <p class="item-subtitle">LPO Albert Einstein - STI2D - Mention Bien</p>
              </div>
            </div>
          </section>
        </div>

        <!-- Side Column -->
        <div class="side-column">
          <!-- Compétences -->
          <section class="cv-section">
            <div class="section-header">
              <h2>Compétences</h2>
            </div>
            <div class="section-content">
              <div class="skill-group">
                <h4>Langages</h4>
                <div class="tech-stack">
                  <span class="tech-text">Java</span> <span class="separator">•</span>
                  <span class="tech-text">PHP</span> <span class="separator">•</span>
                  <span class="tech-text">SQL</span> <span class="separator">•</span>
                  <span class="tech-text">HTML/CSS</span> <span class="separator">•</span>
                  <span class="tech-text">TypeScript</span> <span class="separator">•</span>
                  <span class="tech-text">C#</span>
                </div>
              </div>
              <div class="skill-group" style="margin-top: 20px;">
                <h4>Frameworks & Outils</h4>
                <div class="tech-stack">
                  <span class="tech-text">Spring Boot</span> <span class="separator">•</span>
                  <span class="tech-text">Symfony</span> <span class="separator">•</span>
                  <span class="tech-text">Vue.js</span> <span class="separator">•</span>
                  <span class="tech-text">Angular</span> <span class="separator">•</span>
                  <span class="tech-text">Git/GitLab</span> <span class="separator">•</span>
                  <span class="tech-text">Docker</span> <span class="separator">•</span>
                  <span class="tech-text">Linux</span>
                </div>
              </div>
            </div>
          </section>

          <!-- Langues -->
          <section class="cv-section">
            <div class="section-header">
              <h2>Langues</h2>
            </div>
            <div class="section-content">
              <div class="language-item">
                <span class="lang-name">Français</span>
                <span class="lang-level">Maternel</span>
              </div>
              <div class="language-item">
                <span class="lang-name">Anglais</span>
                <span class="lang-level">B2 (Technique)</span>
              </div>
              <div class="language-item">
                <span class="lang-name">Espagnol</span>
                <span class="lang-level">Scolaire</span>
              </div>
            </div>
          </section>

          <!-- Qualités -->
          <section class="cv-section">
            <div class="section-header">
              <h2>Savoir-être</h2>
            </div>
            <div class="section-content">
              <ul class="soft-skills-list">
                <li><strong>Travail d'équipe</strong><br>Expérience Lead Tech & Mentorat.</li>
                <li><strong>Autonomie</strong><br>Apprentissage autodidacte.</li>
                <li><strong>Gestion du stress</strong><br>Habitué aux deadlines courtes.</li>
              </ul>
            </div>
          </section>

          <!-- Réseaux -->
          <section class="cv-section">
            <div class="section-header">
              <h2>Réseaux</h2>
            </div>
            <div class="section-content">
              <div class="interests-list">
                <a href="https://www.linkedin.com/in/timothé-natté-9795882ab" target="_blank" class="interest-link">
                  LinkedIn
                  <br>
                  https://www.linkedin.com/in/timothé-natté-9795882ab
                </a>
              </div>
            </div>
          </section>

          <!-- Centres d'intérêt -->
          <section class="cv-section">
            <div class="section-header">
              <h2>Intérêts</h2>
            </div>
            <div class="section-content">
              <p class="simple-text">Football, Hardware / IoT</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-facing-decorator';

@Component({})
export default class CVComponent extends Vue {}
</script>

<style scoped>
/* Variables locales pour forcer le thème clair "Papier" */
.project-container {
  --cv-bg: #ffffff;
  --cv-text: #333333;
  --cv-text-light: #666666;
  --cv-accent: #2c3e50; /* Bleu nuit sobre */
  --cv-border: #e0e0e0;

  font-family: 'Inter', 'Segoe UI', Helvetica, Arial, sans-serif;
  line-height: 1.5;
  color: var(--cv-text);
  background-color: var(--background-color); /* Fond de l'app */
  max-width: 1400px; /* Élargi pour aplatir le contenu */
  margin: 0 auto;
  padding: 20px;
  padding-left: 100px;
}



/* Zone "Papier" qui sera imprimée */
.cv-paper {
  background-color: var(--cv-bg);
  padding: 40px;
  box-shadow: 0 0 20px rgba(0,0,0,0.1); /* Effet feuille posée */
}

/* Hero Section */
.compact-hero {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding-bottom: 30px;
  margin-bottom: 30px;
  border-bottom: 2px solid var(--cv-accent);
}

.hero-title {
  font-size: 2.8em;
  font-weight: 800;
  margin: 0 0 5px 0;
  color: var(--cv-accent);
  text-transform: uppercase;
  letter-spacing: -0.5px;
}

.hero-title .highlight {
  color: var(--cv-text);
}

.hero-subtitle {
  font-size: 1.2em;
  color: var(--cv-text-light);
  margin-bottom: 15px;
  font-weight: 500;
}

.profile-description {
  font-size: 1em;
  color: var(--cv-text);
  max-width: 700px; /* Élargi */
  margin-bottom: 20px;
  line-height: 1.6;
}

.hero-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  font-size: 0.9em;
  color: var(--cv-text-light);
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.meta-item i {
  color: var(--cv-accent);
}

.profile-photo-container {
  width: 160px;
  height: 160px;
  border-radius: 50%; /* Rond classique */
  overflow: hidden;
  border: 1px solid var(--cv-border);
}

.profile-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Grid Layout */
.cv-grid {
  display: grid;
  grid-template-columns: 2.5fr 1fr; /* Colonne principale plus large */
  gap: 50px;
}

/* Sections */
.cv-section {
  margin-bottom: 25px; /* Réduit */
}

.section-header {
  margin-bottom: 15px;
  border-bottom: 1px solid var(--cv-border);
  padding-bottom: 5px;
}

.section-header h2 {
  font-size: 1.1em;
  margin: 0;
  color: var(--cv-accent);
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 700;
}

/* Experience Items */
.experience-item {
  margin-bottom: 20px; /* Réduit */
}

.experience-item:last-child {
  margin-bottom: 0;
}

.item-header {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 4px;
}

.item-header h3 {
  font-size: 1.05em;
  color: var(--cv-text);
  margin: 0;
  font-weight: 700;
}

.date {
  font-size: 0.9em;
  color: var(--cv-text-light);
  font-weight: 500;
  white-space: nowrap;
}

.item-subtitle {
  font-weight: 600;
  font-size: 0.95em;
  margin: 0 0 6px 0;
  color: var(--cv-text-light);
}

.item-desc {
  margin: 0 0 6px 0;
  font-size: 0.95em;
}

.detail-list {
  padding-left: 18px;
  margin: 6px 0;
  font-size: 0.9em;
  color: var(--cv-text-light);
}

.detail-list li {
  margin-bottom: 3px;
}

.learning-text {
  font-size: 0.9em;
  color: var(--cv-text);
  margin-top: 8px;
  font-style: italic;
}

.learning-text strong {
  color: var(--cv-accent);
  font-style: normal;
  font-size: 0.9em;
  text-transform: uppercase;
  margin-right: 4px;
}

/* Skills */
.skill-group h4 {
  font-size: 0.95em;
  color: var(--cv-text-light);
  margin: 0 0 8px 0;
  text-transform: uppercase;
  font-weight: 600;
}

.tech-stack {
  font-size: 0.95em;
  line-height: 1.6;
}

.tech-text {
  color: var(--cv-text);
  font-weight: 500;
}

.separator {
  color: var(--cv-border);
  margin: 0 4px;
}

/* Languages & Soft Skills */
.language-item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  font-size: 0.95em;
}

.lang-name {
  font-weight: 600;
}

.lang-level {
  color: var(--cv-text-light);
}

.soft-skills-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.soft-skills-list li {
  margin-bottom: 12px;
  font-size: 0.95em;
  color: var(--cv-text-light);
}

.soft-skills-list strong {
  color: var(--cv-text);
  display: block;
  margin-bottom: 2px;
}

/* Networks */
.interests-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.interest-link {
  color: var(--cv-accent);
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95em;
  border-bottom: 1px solid transparent;
  width: fit-content;
}

.interest-link:hover {
  border-bottom-color: var(--cv-accent);
}

.simple-text {
  font-size: 0.95em;
  color: var(--cv-text);
}

/* Responsive */
@media (max-width: 900px) {
  .cv-grid {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  .project-container {
    padding-left: 90px;
  }
}

@media (max-width: 600px) {
  .compact-hero {
    flex-direction: column-reverse;
    text-align: center;
    align-items: center;
  }
  .hero-meta {
    justify-content: center;
  }
  .project-container {
    padding: 20px;
  }
  .cv-paper {
    padding: 20px;
  }
}
</style>
